import {DOCUMENT, IS_BROWSER, IS_IOS, IS_MOBILE, WINDOW, HAS_TOUCH} from "../../constants/environment";
import './styles.css';
import SweetScroll from "sweet-scroll";

/**
 *  Body Control
 */
class BodyControl {

  static scrollTop = 0;

  // スクロール無効化
  static setUnScroll = () => {
    if (!DOCUMENT.body.classList.contains('un-scroll')) {
      DOCUMENT.body.classList.add('un-scroll');
    }
    if (IS_IOS) {
      // if (!DOCUMENT.body.parentNode.classList.contains('un-scroll')) {
      //   DOCUMENT.body.parentNode.classList.add('un-scroll');
      // }
      //WINDOW.addEventListener('touchmove', BodyControl.onTouchMove, {passive: false});
    }
  };
  static setUnScrollPc = () => {
    if (!DOCUMENT.body.classList.contains('un-scroll-pc')) {
      DOCUMENT.body.classList.add('un-scroll-pc');
    }
    if (IS_IOS) {
      // if (!DOCUMENT.body.parentNode.classList.contains('un-scroll-pc')) {
      //   DOCUMENT.body.parentNode.classList.add('un-scroll-pc');
      // }
      //WINDOW.addEventListener('touchmove', BodyControl.onTouchMove, {passive: false});
    }
  };
  static setUnScrollMb = () => {
    if (!DOCUMENT.body.classList.contains('un-scroll-mb')) {
      DOCUMENT.body.classList.add('un-scroll-mb');
    }
    if (IS_IOS) {
      // if (!DOCUMENT.body.parentNode.classList.contains('un-scroll-mb')) {
      //   DOCUMENT.body.parentNode.classList.add('un-scroll-mb');
      // }
      //WINDOW.addEventListener('touchmove', BodyControl.onTouchMove, {passive: false});
    }
  };

  // BODYのスクロール無効化を解除
  static clearUnScroll = () => {
    if (DOCUMENT.body.classList.contains('un-scroll')) {
      DOCUMENT.body.classList.remove('un-scroll');
    }
    if (DOCUMENT.body.classList.contains('un-scroll-pc')) {
      DOCUMENT.body.classList.remove('un-scroll-pc');
    }
    if (DOCUMENT.body.classList.contains('un-scroll-mb')) {
      DOCUMENT.body.classList.remove('un-scroll-mb');
    }
    if (IS_IOS) {
      // if (DOCUMENT.body.parentNode.classList.contains('un-scroll')) {
      //   DOCUMENT.body.parentNode.classList.remove('un-scroll');
      // }
      // if (DOCUMENT.body.parentNode.classList.contains('un-scroll-pc')) {
      //   DOCUMENT.body.parentNode.classList.remove('un-scroll-pc');
      // }
      // if (DOCUMENT.body.parentNode.classList.contains('un-scroll-mb')) {
      //   DOCUMENT.body.parentNode.classList.remove('un-scroll-mb');
      // }
      //WINDOW.removeEventListener('touchmove', BodyControl.onTouchMove, {passive: false});
    }
  };

  // モーダルウィンドウ開く
  static openModal = () => {
    if (HAS_TOUCH) {
      // スクロールを無効にする
      BodyControl.scrollTop = WINDOW.pageYOffset;

      // DOCUMENT.body.style.position = 'fixed';
      if (WINDOW.MZD_SCROLL_DEPTH_TARGET && WINDOW.MZD_SCROLL_DEPTH_TARGET.list) {
        if (WINDOW.location) {
          let flg = false;
          // リストと一致しているか
          WINDOW.MZD_SCROLL_DEPTH_TARGET.list.map((url)=> {
            if (0 <= String(WINDOW.location.href).indexOf(url)) {
              flg = true;
            }
          })
          // 不許可リストにある場合は除去
          WINDOW.MZD_SCROLL_DEPTH_TARGET.ignore.map((url)=> {
            if (0 <= String(WINDOW.location.href).indexOf(url)) {
              flg = false;
            }
          })
          if (flg) {
            DOCUMENT.body.style.position = 'absolute';
          } else {
            DOCUMENT.body.style.position = 'fixed';
          }
        }
      } else {
        DOCUMENT.body.style.position = 'fixed';
      }

      DOCUMENT.body.style.top = -BodyControl.scrollTop + 'px';
    }

    if (!DOCUMENT.body.classList.contains('modal-open')) {
      DOCUMENT.body.classList.add('modal-open');
    }

    setTimeout(()=> {
      const elements = DOCUMENT.body.querySelectorAll('main > div > div');
      if (elements) {
        Array.prototype.slice.call(elements, 0).forEach((element)=> {
          const openedVideo = element.querySelectorAll('.Video .is-open');
          if (1 <= openedVideo.length) {
            if (!element.classList.contains('modal-open-item')) {
              element.classList.add('modal-open-item');
            }
          }
        });
      }
    }, 100);

  };

  // モーダルウィンドウ閉じる
  static closeModal = () => {
    if (DOCUMENT.body.classList.contains('modal-open')) {
      DOCUMENT.body.classList.remove('modal-open');
    }
    // if (IS_MOBILE) {
    if (HAS_TOUCH) {
      // スクロール無効を解除する
      // WINDOW.scrollTo(0, BodyControl.scrollTop);
      // if (DOCUMENT.body.parentNode.classList.contains('modal-open')) {
      //   DOCUMENT.body.parentNode.classList.remove('modal-open');
      // }
      //WINDOW.removeEventListener('touchmove', BodyControl.onTouchMove, {passive: false});

      DOCUMENT.body.style.position = 'static';
      DOCUMENT.body.style.top = '0px';

      WINDOW.scrollTo(0, BodyControl.scrollTop);

    }

    const elements = DOCUMENT.body.querySelectorAll('main > div > div');
    if (elements) {
      Array.prototype.slice.call(elements, 0).forEach((element)=> {
        if (element.classList.contains('modal-open-item')) {
          element.classList.remove('modal-open-item');
        }
      });
    }

    // if (!IS_MOBILE && HAS_TOUCH) {
    //   WINDOW.removeEventListener('touchmove', BodyControl.onTouchMove, {passive: false});
    // }

  };

  static onTouchMove = (e) => {
    e.preventDefault();
  };

  // サブナビゲーションの高さ取得
  static getSubNavigationHeight = (e) => {
    const navigation = DOCUMENT.body.getElementsByClassName('StandardPage__navigation')[0] || null;
    if (!navigation) {
      return 0;
    } else {
      return navigation.clientHeight;
    }
  };

  // IDでスクロール
  static scrollToElementId = (id, options = {}, callBack = () => {}) => {
    const element = document.querySelector(`[data-id="${id}"]`);
    if (!IS_BROWSER || !id || !element) {
    } else {
      BodyControl.scrollToNode(element, {...options}, callBack);
    }
  };

  // Nodeへスクロール
  static scrollToNode = (target, {duration = 1000, container = 'body, html', offset = -BodyControl.getSubNavigationHeight()} = {}, callback = () => {}) => {
    if (!IS_BROWSER || !target) return;
    const sweetScroll = new SweetScroll({duration, offset, stopPropagation: false, afterScroll: callback}, container);
    sweetScroll.toElement(target);
  };

  // URLパラメータ取得
  static getUrlParameter = (name) => {
    if (!WINDOW) return null;
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    if (results === null) {
      return null;
    } else {
      let result = decodeURIComponent(results[1].replace(/\+/g, ' '))
      return (result === null || result === '') ? null : result;
    }
  };

  // GTMイベント
  static setGTMEvent = (data)=> {
    if (!window) return;
    //console.log('GTMイベント', data);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }

}

export default BodyControl;



// WEBPACK FOOTER //
// ./src/components/body/index.jsx